import type { PracticalProject } from "../../data";

export const coffeeDaas: PracticalProject = {
  id: "coffee-daas",
  num: 5,
  title: "実践プロジェクト⑤ Coffee Life as a Service DX共創プロジェクト — 企画依頼書を読み解く",
  description:
    "株式会社コーヒークラフト向けの DX 提案コンペ。企画依頼書 (RFP) 1 枚を読み解き、経営課題・開示データ・評価軸を正確に把握する",
  duration: "5 日〜3 週間",
  techStack: [],
  difficulty: "beginner",
  phase: "Phase 3 後半",
  learningOutcomes: [
    "企画依頼書 (RFP) から経営課題・実施条件・評価軸を正確に読み取れるようになる",
  ],
  chapters: [{ num: 1, title: "企画依頼書" }],
};
